<template>
  <router-view />
</template>

<script></script>

<style lang="scss">
@import "./assets/all.scss";

// 切版格線,切版完後要刪除
// * {
//   outline: 1px solid #000;
// }
</style>
